import { Toast } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .toast' ) )
     .forEach( toastNode => new Toast( toastNode ) )
